import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ContentUpdate } from '../../services';

export const fetchContentUpdate = createAsyncThunk(
    'contentUpdate/fetchContentUpdate',
    async ({ file, footerText, footerText2, bannerText, bannerText2, bannerText3, showcaseText, showcaseText2, showcaseText3, specialField1, specialField2, specialField3, specialField4, specialField5, specialField6 }) => {
        const response = await ContentUpdate(file, footerText, footerText2, bannerText, bannerText2, bannerText3, showcaseText, showcaseText2, showcaseText3, specialField1, specialField2, specialField3, specialField4, specialField5, specialField6);
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const contentUpdateSlice = createSlice({
    name: 'contentUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContentUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContentUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchContentUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default contentUpdateSlice.reducer;
